import { apiServer } from "../config";

export type MapSettings = {
  mapUpdate: boolean;
  mapUpdateTimeout: string;
  mapUpdateDistance: string;
  mapUpdateWithZoom: boolean;
  mapUpdateShowLoading: boolean;
};

export async function loadMapSettings() {
  const response = await fetch(`${apiServer + "/appsettings/map_settings"}`, {
    method: "GET",
  });
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  } else {
    return data.mapDefaultSettings.progressiveSearch as MapSettings;
  }
}

export type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

export type Geometry = {
  location: {
    lat: number;
    lng: number;
  };
  location_type: string;
  viewport: {
    northeast: {
      lat: number;
      lng: number;
    };
    southwest: {
      lat: number;
      lng: number;
    };
  };
};

export type NavigationPoint = {
  location: {
    latitude: number;
    longitude: number;
  };
  restricted_travel_modes: string[];
};

export type PlusCode = {
  compound_code: string;
  global_code: string;
};

export type GeocodeResult = {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: Geometry;
  navigation_points?: NavigationPoint[];
  place_id: string;
  plus_code?: PlusCode;
  types: string[];
};

export type GeocodeData = {
  results: GeocodeResult[];
  status: string;
  plus_code?: PlusCode;
};

export type ReverseGeocodeResult = {
  status: string;
  message: string;
  data: GeocodeData;
};

export async function reverseGeocode(
  latitude: number,
  longitude: number
): Promise<ReverseGeocodeResult> {
  const params = new URLSearchParams({
    latitude: String(latitude),
    longitude: String(longitude),
  });

  const url = `${apiServer}/business/geocode?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Reverse geocoding failed: ${response.statusText}`);
  }

  const data = await response.json();

  if (data.status === "error") {
    throw new Error(data.message || "Reverse geocoding failed");
  }

  return data;
}
